import React, { useState } from "react";
import "react-bulma-components/dist/react-bulma-components.min.css";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AnchorDashboard from "./Components/AnchorNew/AnchorDashboard";
import "./Components/Common/Common.scss";
import SideBar from "./Components/Common/SideBar";
import { userContext } from "./Components/Contexts/userContext";
import Login from "./Components/Login/Login";
import ChangePassword from "./Components/ResetPassword/ChangePassword";
import ResetPassword from "./Components/ResetPassword/ResetPassword";
import ClosingBalanceUpload from "./Components/Vendor/ClosingBalanceUpload";
import OperationsPage from "./Components/Vendor/OperationsPage";
import ReportTemplates from "./Components/Vendor/ReportTemplates";
import UploadInvoice from "./Components/Vendor/UploadInvoice";
import VendorDashboard from "./Components/Vendor/VendorDashboard";
import VendorSideDashboard from "./Components/VendorNew/VendorSideDashboard";
import { ActorTypes, FrontendActor } from "./entity/models/FrontendActor";

const App = () => {
  const [actor, setActor] = useState<FrontendActor>(() => {
    const localData = localStorage.getItem("actor");
    try {
      return localData ? JSON.parse(localData) : null;
    } catch (e) {
      return null;
    }
  });

  const AdminRoute = ({ component: Component, ...rest }) => {
    return (
      <Route
        {...rest}
        render={(props) => {
          if (actor && actor.actorType === "Admin") {
            return <Component {...props} />;
          } else {
            return <Redirect to="/admin/dashboard" />;
          }
        }}
      />
    );
  };

  const AnchorRoute = ({ component: Component, ...rest }) => {
    return (
      <Route
        {...rest}
        render={(props) => {
          if (actor && actor.actorType === ActorTypes.Anchor) {
            return <Component {...props} />;
          } else {
            return <Redirect to="/" />;
          }
        }}
      />
    );
  };

  const AdminOrAnchorRoute = ({ component: Component, ...rest }) => {
    return (
      <Route
        {...rest}
        render={(props) => {
          if (actor && (actor.actorType === ActorTypes.Anchor || actor.actorType === ActorTypes.Admin)) {
            return <Component {...props} />;
          } else {
            return <Redirect to="/" />;
          }
        }}
      />
    );
  };

  const VendorRoute = ({ component: Component, ...rest }) => {
    return (
      <Route
        {...rest}
        render={(props) => {
          if (actor && actor.actorType === ActorTypes.Vendor) {
            return <Component {...props} />;
          } else {
            return <Redirect to="/" />;
          }
        }}
      />
    );
  };

  return (
    <BrowserRouter>
      <userContext.Provider value={{ actor, setActor }}>
        <SideBar />
        <Switch>
          <Route exact={true} path="/">
            <Login />
          </Route>
          <Route exact={true} path="/reset/:token/:accountType">
            <ChangePassword />
          </Route>
          <Route exact={true} path="/reset">
            <ResetPassword />
          </Route>

          {/* AnchorRoute for anchor paths */}
          <AnchorRoute exact={true} path="/anchor/dashboard" component={AnchorDashboard} />
          <VendorRoute exact={true} path="/vendor/dashboard" component={VendorSideDashboard} />

          {/* AdminRoute for admin paths */}

          <AdminRoute exact={true} path="/admin/dashboard" component={VendorDashboard} />
          <AdminRoute exact={true} path="/admin/operations" component={OperationsPage} />
          <AdminRoute exact={true} path="/admin/reportTemplates" component={ReportTemplates} />

          {/* AdminOrAnchorRoute for shared paths */}
          <AdminOrAnchorRoute
            exact
            path={["/admin/uploadInvoices", "/anchor/uploadInvoices"]}
            component={UploadInvoice}
          />
          <AdminOrAnchorRoute
            exact
            path={["/admin/uploadClosingBalance", "/anchor/uploadClosingBalance"]}
            component={ClosingBalanceUpload}
          />

          <Redirect to="/" />
        </Switch>
      </userContext.Provider>
      <ToastContainer autoClose={4000} icon={false} closeButton={false} draggable limit={6} stacked />
    </BrowserRouter>
  );
};

export default App;
